<template>
  <div>
    <ul id="products-list">
      <li class="prod_el" v-for="prod in products">
        <ProductEn v-bind:prod="prod"></ProductEn>
      </li>
    </ul>
    <ExtraTip v-if="extra" :extra="extra"></ExtraTip>
  </div>
</template>
<script>
  import ProductEn from '@/components/product_en'
  import ExtraTip from '@/components/products_extra_tip'
  export default {
    name: 'ProductGroup',
    data () {
      return {
      }
    },
    props: ['products','group','extra'],
    components: { ProductEn, ExtraTip }
  };
</script>
<style scoped>
  h1,h2 {
    color: black;
  }
  ul {
    list-style: none;
    padding-left: 10px;
  }
  li {
    color: black;
  }
  span {
    display: none;
    margin-left: 10px;
  }
  .show {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/product_group.vue